import React from 'react';
import MenuPageWrapper from '../Wrappers/MenuPageWrapper.jsx';

export default class AppsWrapper extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const menuItems = [
            { icon: "home", title: "Remote Desktop Client", href: "/apps" },
        ];

        return (
            <MenuPageWrapper title={this.props.title} menuItems={menuItems} loading={this.props.loading}>
                {this.props.children}
            </MenuPageWrapper>
        );
    }
}
